// @flow

import {
  GET_USERS_SUCCESS,
  GET_USERS_FAILURE,
  GET_USERS_REQUEST
} from '../actions/users'

import { UPDATE_ACCOUNT_SUCCESS } from '../actions/account'

const initialState: {
  isFetching: boolean,
  items: Array<Object>
} = {
  isFetching: false,
  items: []
}

export function users(state: Object = initialState, action: Object): Object {
  switch (action.type) {
    case GET_USERS_REQUEST:
      return Object.assign({}, state, {
        isFetching: true
      })

    case GET_USERS_SUCCESS:
      return Object.assign({}, state, {
        isFetching: false,
        items: action.users
      })

    case GET_USERS_FAILURE:
      return Object.assign({}, state, {
        isFetching: false
      })

    case UPDATE_ACCOUNT_SUCCESS:
      const newUsers = []
      const newUser = {}
      Object.assign(newUsers, state.items)
      const oldUserIndex = state.items.findIndex(
        user => user.id === action.userId
      )
      const oldUser = state.items[oldUserIndex]
      Object.assign(newUser, oldUser)

      newUser.photo_url = action.file
      newUser.about = action.about
      newUsers.splice(oldUserIndex, 1, newUser)

      return Object.assign({}, state, {
        isUpdatingAccount: false,
        items: newUsers
      })

    default:
      return state
  }
}
